import './EditDropdownMenu.scoped.sass'

import { ReactComponent as PencilIcon } from '@/assets/icons/pencil-icon-2.svg'

import { ReactComponent as TrashIcon } from '@/assets/icons/trash-icon-2.svg'
import modalService from '@/services/modal.service'
import { useEffect } from 'react'
import dropdownService from '@/components/DropdownMenu/dropdown.service'
import AddContactLabelModal from '../../AddcontactLabelModal/AddContactLabelModal'
import contactslabelsService from '@/app-domains/contactslabels/contactslabels.service'

export function EditContactLabelDropdownMenu ({ label, event }) {
  const iconSize = { width: '18px', height: '18px' }
  const menuOptions = [

    {
      icon: <PencilIcon style={iconSize} />,
      title: 'Edit',
      action: () => {
        dropdownService.close()
        modalService.open(<AddContactLabelModal type='edit' label={label} closeAddLabelModal={() => modalService.close()} />)
      },
      color: 'normal'
    },
    {
      separator: true
    },
    
    {
      icon: <TrashIcon style={iconSize} />,
      title: 'Delete',
      action: () => {
        dropdownService.close()
        contactslabelsService.removeContactLabel(label)
          .then(() => {
            // FIXME: Update current filter if it matches the one we deleted
            /*
            if (threadsService.getCurrentFilter().type === 'Label') {
              if (threadsService.getCurrentFilter().value === label.composedid) {
                threadsService.applyFilterFor('all', 'All messages', 'all', true)
              }
            }
            */
          })
          .catch((err) => {
            throw new Error(err)
          })
      },
      color: 'red'
    }
  ]

  useEffect(() => {
    dropdownService.open(menuOptions, 'right', event)
  }, [])

  return <></>
}
